// /blog/mindfulness/page.js
import React, { useEffect } from "react";
import { Container, Header, Segment, Card, Image, Icon } from "semantic-ui-react";
import Feed from '@components/Feed';

const Mindfulness = () => {
  // Add Open Graph meta tags for mindfulness category page
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    document.title = 'Mindfulness Articles - Cloud CZR | Meditation & Mindful Living';
    updateMetaTag('og:title', 'Mindfulness Articles - Cloud CZR | Meditation & Mindful Living');
    updateMetaTag('og:description', 'Cultivate balance and mindfulness through intentional practices. Explore meditation techniques, NLP integration, and mindful living strategies.');
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:image', `${window.location.origin}/assets/CloudChiRho.png`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', 'Cultivate balance and mindfulness through intentional practices. Explore meditation techniques, NLP integration, and mindful living strategies.', false);
    updateMetaTag('twitter:title', 'Mindfulness Articles - Cloud CZR | Meditation & Mindful Living', false);
    updateMetaTag('twitter:description', 'Cultivate balance and mindfulness through intentional practices. Explore meditation techniques, NLP integration, and mindful living strategies.', false);
  }, []);

  const path = 'blog/mindfulness';
  const mindfulnessTopics = [
    {
      title: "Meditation Practices",
      description: "Explore various meditation techniques to bring peace and balance to your life.",
      image: "https://example.com/meditation.jpg",
    },
    {
      title: "Mindful Living",
      description: "Learn about integrating mindfulness into everyday activities for a more fulfilled life.",
      image: "https://example.com/mindful_living.jpg",
    },
  ];

  return (
    <Container style={{ marginTop: "2em" }}>
      <Header as='h1' textAlign='center' icon style={{ color: '#a9885c', backgroundColor: '#702963' }}>
        <Icon name='cloud' style={{ color: '#a9885c' }}/>
        The Mindfulness Blog
        <Header.Subheader style={{ color: '#a9885c' }}>
        Cultivating a balanced and mindful life through intentional practices.
        </Header.Subheader>
      </Header>
      <Feed path={path} />
    </Container>
  );
};

export default Mindfulness;
